const DeviceManagement = () => {
    return <>
        <div className="p-4 bg-white bg-opacity-20 rounded-md text-white">
            DeviceManagement
        </div>
    </>
}

export default DeviceManagement